import { Locales } from "i18n/config"
import { createSelector } from "reselect"
import State from "../state"

const getCurrentUserState = (state: State) => state.currentUser
export const getCurrentUser = createSelector(getCurrentUserState, state => state.data)
export const getUserSettings = (state: State) => state.currentUser.userSettingsData

export const loading = (state: State): boolean => state.currentUser.loading
export const dispatched = (state: State): boolean => state.currentUser.dispatched

export const getCurrentUserLocale = (state: State): Locales => state.currentUser.data?.locale || Locales.NL
export const userAndTokenDispatched = (state: State): boolean =>
  state.currentUser.dispatched && state.authorization.dispatched
